// Release Generator Constants

export const INITIAL_FORM_DATA = {
  // Basic Information
  name: "",
  description: "",
  
  // Scheduling
  scheduledAt: "",
  
  // Templates
  templates: [],
  
  // Audience Configuration
  segments: [],
  includeUnregistered: true,
  targetLanguagesEnabled: false,
  targetLanguages: ["any"],
  targetPlatformsEnabled: false,
  targetPlatforms: ["any"],
  ltvFilterEnabled: false,
  ltvAmount: null,
  ltvOperator: "gte",
  deliveryFilterEnabled: false,
  deliveryOperator: "not_seen",
  deliveryReleases: [],
  audienceShareEnabled: false,
  audienceShare: 100
}

export const STEPS = [
  {
    id: 1,
    title: "Basic Info"
  },
  {
    id: 2,
    title: "Templates"
  },
  {
    id: 3,
    title: "Audience"
  },
  {
    id: 4,
    title: "Review"
  }
]


export const PLATFORMS = [
  { value: "any", label: "Any Platform" },
  { value: "android", label: "Android" },
  { value: "ios", label: "iOS" },
  { value: "web", label: "Web" },
  { value: "mac", label: "Mac" },
  { value: "windows", label: "Windows" },
  { value: "linux", label: "Linux" }
]